import type { FieldControl } from '../fieldset/ui-fieldset.type';
import type { AttributesConfig, ElementConfig } from '../ui-element.type';

/**
 * Create an ElementConfig based on FieldControl.
 * @param {FieldControl} control
 * @returns {ElementConfig}
 * @private
 */
export function fromControlConfig(control: FieldControl): ElementConfig {
    const inputAttributes: AttributesConfig = control.control?.attributes || {};

    return {
        tagName: 'ui-datepicker',
        attributes: control.attributes,
        children: [
            {
                tagName: 'input',
                attributes: inputAttributes,
            },
        ],
    };
}
